/**
 * 对接主播管理台通用mixins
 */

import * as storeConfigApi from "@api/store-config"
import * as gamePropsApi from "@api/gameProps"
import * as url from "@utils/url"
import * as reportDict from "@constants/report-dictonary"
import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      anchorConfig: {}
    }
  },
  computed: {
    ...mapGetters(["currentItem", "vmallConfigByAMSID"]),
    anchorName() {
      return this.anchorConfig.anchorName && decodeURIComponent(this.anchorConfig.anchorName)
    },
    // 主播购买指引（主播活动文案，标签，跳转链接等）
    anchorBuyGuide() {
      if (this.anchorConfig && this.anchorConfig.buyGuideList && this.anchorConfig.buyGuideList.length) {
        let itemId = ""
        if (url.getParam("productItemId")) {
          itemId = url.getParam("productItemId")
        } else if (this.$route.params.goodsid && this.vmallConfigByAMSID[this.$route.params.goodsid]) {
          itemId = this.vmallConfigByAMSID[this.$route.params.goodsid].itemId
        }

        // 活动广告有主播维度和物品维度的
        return gamePropsApi.selectAnchorBuyGuide({
          buyGuideList: this.anchorConfig.buyGuideList,
          itemId: itemId
        })
      } else {
        return {}
      }
    },
    hasAnchorBuyGuide() {
      return this.anchorBuyGuide && this.anchorBuyGuide.url
    },
    showQA() {
      return this.currentItem && this.currentItem.liveBuyQA ? true : false
    }
  },
  methods: {
    ...mapActions(["reportUserAction"]),
    /**
     * 获取主播配置
     * @param {*}
     * offerid
     * tx_chan_type
     * tx_seller_id
     */
    getAnchorConfig({ offerid, tx_chan_type, tx_seller_id }) {
      if (!offerid || !tx_chan_type || !tx_seller_id) return
      let storeConfigEnv = url.getParam("store_config_env")

      let anchorConfigPath = `https://pay.qq.com/h5/store_config/productList/${tx_chan_type}/${offerid}.json`
      let anchorConfigSandboxPath = `https://pay.qq.com/h5/store_config/productList/${tx_chan_type}/${offerid}_sandbox.json`

      let now = window._serverTime ? new Date(window._serverTime) : new Date()
      if (!gamePropsApi.isValidDate(now)) now = new Date()
      let timeStamp = now.getTime()

      // TODO 暂未支持md5缓存
      return Promise.resolve()
        .then(() => {
          return storeConfigApi
            .getConfigFromLocalStorage({
              configKey:
                storeConfigEnv && storeConfigEnv > 0
                  ? `store_anchorConfig_sandbox_${tx_chan_type}_${offerid}`
                  : `store_anchorConfig_${tx_chan_type}_${offerid}`,
              configUrl: storeConfigEnv && storeConfigEnv > 0 ? anchorConfigSandboxPath : anchorConfigPath,
              configVersion: timeStamp // 如果取不到直出的configVersion，则不缓存(时间戳作为key)
            })
            .then(anchorConfig => {
              return anchorConfig.content
            })
        })
        .then(anchorConfig => {
          return (anchorConfig && anchorConfig[tx_seller_id]) || {}
        })
    },

    /**
     * 获取带货店铺配置
     * @param {*}
     * offerid
     * tx_chan_type
     * tx_seller_id
     */
    getAnchorShopConfig({ groupid_bizid }) {
      if (!groupid_bizid) return Promise.resolve()
      let storeConfigEnv = url.getParam("store_config_env")

      let anchorConfigPath = `https://pay.qq.com/h5/store_config/anchor_shop_config/anchor_shop_config/${groupid_bizid}.json`
      let anchorConfigSandboxPath = `https://sandbox.pay.qq.com/h5/store_config/anchor_shop_config/anchor_shop_config/${groupid_bizid}.json`

      let now = window._serverTime ? new Date(window._serverTime) : new Date()
      if (!gamePropsApi.isValidDate(now)) now = new Date()
      let timeStamp = now.getTime()

      return storeConfigApi.getConfigFromLocalStorage({
        configUrl: storeConfigEnv && storeConfigEnv > 0 ? anchorConfigSandboxPath : anchorConfigPath,
        configKey:
          storeConfigEnv && storeConfigEnv > 0 ? `store_anchorShop_sandbox_${groupid_bizid}` : `store_anchorShop_${groupid_bizid}}`,
        configVersion: timeStamp
      })
    },

    goToQAPage(title) {
      this.$router.push({
        path: "/iframePage",
        query: {
          iframeUrl: this.currentItem.liveBuyQA,
          title: title
        }
      })
      this.reportUserAction({
        iformat: reportDict.CLICK.DETAIL_OUTER_NAV_QA,
        pfStructure: this.$route.query.pfStructure
      })
    }
  }
}
